<template>
    <div>
        <ul style="display: flex; flex-wrap: wrap;">
            <li style="width:100px;" v-for="(item, index) in items" :key="index">
            <Input ref="name" v-model="items[index]">
                <Button slot="append" @click="del(index)" type="error" icon="md-close" size="small"></Button>
            </Input>
            
        </li>
        </ul>
        

        <Button @click="add" type="error" icon="md-add" size="small"></Button>
    </div>

</template>
<script>
export default {
    props: ['data'],
    model: {
        prop: 'data',
        event: 'bbb'
    },
    data() {
        return {
            items: []
        }
    },
    methods: {
        ff() {
            this.items = this.data;
        },
        add() {
            this.items.push('');
            setTimeout(()=>{
                this.$refs.name[this.items.length-1].focus();
            },200)
        },
        del(index) {

            this.items.splice(index, 1)
        },
    },
    mounted() {
        this.ff();
    },
    watch: {
        data() {
            this.ff();
        }

    }
}
</script>


// WEBPACK FOOTER //
// src/components/diaodu/alotItem.vue